// Locale is presentation-only: it never selects currency, offers or payment routes.
export const LANGUAGES = Object.freeze([
 {code:'zh-Hant',name:'繁體中文'}, {code:'en',name:'English'}, {code:'ja',name:'日本語'},
 {code:'ko',name:'한국어'}, {code:'vi',name:'Tiếng Việt'}, {code:'th',name:'ไทย'},
 {code:'es',name:'Español'}, {code:'fr',name:'Français'}, {code:'de',name:'Deutsch'}
]);
export const DEFAULT_LANGUAGE='zh-Hant';
export const LANGUAGE_STORAGE_KEY='LANGUAGE';
// Only SDK language selection / authenticated preference restore writes this key.
export const SDK_LANGUAGE_STORAGE_KEY='op.sdk.language.choice.v1';
export const SDK_ACTIVE_LANGUAGE_KEY='op.sdk.language.active.v1';
export function normalizeLanguage(value) {
 if(typeof value!=='string')return DEFAULT_LANGUAGE;
 const lower=value.trim().replace(/_/g,'-').toLowerCase();
 if(lower==='ch'||/^zh(?:-|$)/.test(lower))return DEFAULT_LANGUAGE;
 if(lower==='jp')return 'ja';
 const exact=LANGUAGES.find(x=>x.code.toLowerCase()===lower);
 if(exact)return exact.code;
 const base=lower.split('-')[0];
 return LANGUAGES.some(x=>x.code===base)?base:DEFAULT_LANGUAGE;
}
// Device language is used only when this browser has no saved choice.
export function deviceLanguage(device) {
 const nav=device||(typeof navigator!=='undefined'?navigator:null);
 const value=nav&&(nav.language||(Array.isArray(nav.languages)&&nav.languages[0]));
 if(typeof value!=='string'||!value.trim())return 'en';
 const lower=value.trim().replace(/_/g,'-').toLowerCase();
 if(lower==='ch'||/^zh(?:-|$)/.test(lower))return 'zh-Hant';
 const base=lower==='jp'?'ja':lower.split('-')[0];
 return LANGUAGES.some(item=>item.code===base)?base:'en';
}
export function readLanguage(storage,device) {
 try {const target=storage||(typeof window!=='undefined'?window.localStorage:null);
 const saved=target&&(target.getItem(SDK_LANGUAGE_STORAGE_KEY)||target.getItem(LANGUAGE_STORAGE_KEY));
 if(typeof saved==='string'&&saved.trim())return normalizeLanguage(saved);}
 catch(_){}
 return deviceLanguage(device);
}
export function rememberLanguage(value,storage) {
 const language=normalizeLanguage(value);
 try {const target=storage||(typeof window!=='undefined'?window.localStorage:null);
 if(target)target.setItem(LANGUAGE_STORAGE_KEY,language);}catch(_){}
 return language;
}

// Freeze the boot locale across page navigation / OS-triggered WebView reloads.
// OS language is consulted only when neither a choice nor an active session exists.
function browserStorage(name){try{return typeof window!=='undefined'?window[name]:null;}catch(_){return null;}}
export function readActiveLanguage(storage,session,device){
 const target=storage||browserStorage('localStorage');
 const active=session||browserStorage('sessionStorage');
 let value;
 try{value=target&&target.getItem(SDK_LANGUAGE_STORAGE_KEY);}catch(_){}
 try{if(!value)value=active&&active.getItem(SDK_ACTIVE_LANGUAGE_KEY);}catch(_){}
 // Native hosts seed LANGUAGE from the phone. It is not evidence of a manual
 // SDK choice and must never become the source of truth during a WebView restart.
 const language=value?normalizeLanguage(value):deviceLanguage(device);
 try{if(active)active.setItem(SDK_ACTIVE_LANGUAGE_KEY,language);}catch(_){}
 return language;
}
export function rememberSdkLanguage(value,storage,session){
 const language=normalizeLanguage(value);
 const target=storage||browserStorage('localStorage');
 const active=session||browserStorage('sessionStorage');
 // Save the protected value before the legacy write, which native containers may observe.
 try{if(target)target.setItem(SDK_LANGUAGE_STORAGE_KEY,language);}catch(_){}
 try{if(active)active.setItem(SDK_ACTIVE_LANGUAGE_KEY,language);}catch(_){}
 rememberLanguage(language,target);
 return language;
}
